import React, {Fragment} from 'react';
import * as PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { rootStore, constants, workbenchController } from 'cv-react-core';

import Route from './Route';
import WorkbenchPage from '../components/pages/WorkbenchPage/WorkbenchPage';
import LoadingIndicator from '../components/modal/LoadingIndicator';
import ErrorRouteModal from '../components/modal/ErrorRouteModal';

const {
    ui,
} = constants;
const {
    MODAL_DIALOG_ID,
    MODAL_DIALOG_STORE_INFO,
    WORKBENCH_UI_OBJECT_ID,
} = ui;

@observer
class WorkbenchRoute extends Route {
    static propTypes = {
        onOpenLauncher: PropTypes.func,
    };

    render() {
        const {
            sessionStore,
            uiStore,
        } = rootStore;
        const {
            selectedWorkbenchStore,
        } = sessionStore;

        // Set browser tab name to the workbench name.
        // Doing this on each route for consistency for now.
        const { workbench } = selectedWorkbenchStore;
        document.title = workbench.name;
        const loadingProps = {
            objectId: WORKBENCH_UI_OBJECT_ID,
            uiStore,
        };
        return (
            <Fragment>
                { React.createElement(LoadingIndicator, { ...loadingProps }) }
                { React.createElement(ErrorRouteModal, { ...loadingProps }) }
                <WorkbenchPage
                    workbenchStore={ selectedWorkbenchStore }
                    onOpenLauncher={ this.handleOnOpenLauncher }
                    onTransition={ this.handleTransition }
                    onError={ this.handleError } />
            </Fragment>
        );
    }

    componentDidMount() {
        const { uiStore } = rootStore;
        workbenchController.clearGloballyBusy(WORKBENCH_UI_OBJECT_ID, uiStore);
        uiStore.removeValueForUIObject(MODAL_DIALOG_ID, MODAL_DIALOG_STORE_INFO);
    }

    handleOnOpenLauncher = (workbenchStore, launcher, isInitialLaunchAction, modifiers) => {
        const { uiStore } = rootStore;
        workbenchController.performWorkbenchAction(uiStore, workbenchStore, this.handleTransition, this.handleError, launcher, isInitialLaunchAction, modifiers);
        const { onOpenLauncher } = this.props;
        if (onOpenLauncher) onOpenLauncher();
    }
}

export default WorkbenchRoute;
